import { AxiosRequestConfig } from 'axios';

import { BaseApi } from '@trukt/portal-utils/BaseApi';

import { AccountService } from './services/AccountService/AccountService';
import { ActivityService } from './services/ActivityService';
import { AttachmentServices } from './services/AttachmentServices/AttachmentServices';
import { ClientServices } from './services/ClientServices/ClientServices';
import { CommodityService } from './services/CommodityService/CommodityService';
import { CompanyService } from './services/CompanyServices/CompanyService';
import { FileServices } from './services/FileServices/FileServices';
import { GroupService } from './services/GroupService/GroupService';
import { InspectionService } from './services/InspectionService/InspectionService';
import { JobService } from './services/JobService/JobService';
import { LaneService } from './services/LaneService/LaneService';
import { LoadboardService } from './services/LoadboardService/LoadboardService';
import { NoteService } from './services/NoteService/NoteService';
import { OrderService } from './services/OrderServices/OrderServices';
import { ReportServices } from './services/ReportServices/ReportServices';
import { TerminalAssignmentService } from './services/TerminalAssignmentService/TerminalAssignmentService';
import { TerminalService } from './services/TerminalService/TerminalService';
import { UserRoleService } from './services/UserRoleService/UserRoleService';
import { UserService } from './services/UserService/UserService';
import { VendorServices } from './services/VendorServices/VendorServices';
import { PicklistService } from './services/PicklistService';
import { VehicleService } from './services/VehicleService';
import { EquipmentService } from './services/EquipmentService';
import { InvoiceService } from './services/InvoiceService';
import { CaseService } from './services/CaseService';
import { LineService } from './services/LineService';
import { CoupaService } from './services/CoupaService';
import { StopService } from './services/stop-service';
import { ContactServices } from './services/contact-services';
import { IntegrationService } from './services/integration-service';
import { CargoTelService } from './services/cargotel-service';
import { BulkImportServices } from './services/BulkImportServices';

class TruktTmsApi extends BaseApi {
  account: AccountService;
  activity: ActivityService;
  bulkImport: BulkImportServices;
  cargotel: CargoTelService;
  case: CaseService;
  client: ClientServices;
  contact: ContactServices;
  vendor: VendorServices;
  commodity: CommodityService;
  equipment: EquipmentService;
  integration: IntegrationService;
  company: CompanyService;
  order: OrderService;
  attachments: AttachmentServices;
  file: FileServices;
  user: UserService;
  report: ReportServices;
  inspection: InspectionService;
  invoice: InvoiceService;
  line: LineService;
  note: NoteService;
  job: JobService;
  loadboard: LoadboardService;
  terminal: TerminalService;
  terminalAssignment: TerminalAssignmentService;
  lane: LaneService;
  userRole: UserRoleService;
  group: GroupService;
  picklist: PicklistService;
  vehicle: VehicleService;
  coupa: CoupaService;
  stop: StopService;

  constructor(config: AxiosRequestConfig) {
    super(config);

    this.account = new AccountService(this.instance);
    this.activity = new ActivityService(this.instance);
    this.bulkImport = new BulkImportServices(this.instance);
    this.cargotel = new CargoTelService(this.instance);
    this.case = new CaseService(this.instance);
    this.client = new ClientServices(this.instance);
    this.contact = new ContactServices(this.instance);
    this.vendor = new VendorServices(this.instance);
    this.commodity = new CommodityService(this.instance);
    this.company = new CompanyService(this.instance);
    this.order = new OrderService(this.instance);
    this.attachments = new AttachmentServices(this.instance);
    this.file = new FileServices(this.instance);
    this.user = new UserService(this.instance);
    this.loadboard = new LoadboardService(this.instance);
    this.inspection = new InspectionService(this.instance);
    this.invoice = new InvoiceService(this.instance);
    this.line = new LineService(this.instance);
    this.note = new NoteService(this.instance);
    this.job = new JobService(this.instance);
    this.report = new ReportServices(this.instance);
    this.terminal = new TerminalService(this.instance);
    this.terminalAssignment = new TerminalAssignmentService(this.instance);
    this.lane = new LaneService(this.instance);
    this.userRole = new UserRoleService(this.instance);
    this.group = new GroupService(this.instance);
    this.picklist = new PicklistService(this.instance);
    this.vehicle = new VehicleService(this.instance);
    this.equipment = new EquipmentService(this.instance);
    this.coupa = new CoupaService(this.instance);
    this.stop = new StopService(this.instance);
    this.integration = new IntegrationService(this.instance);
  }
}

export { TruktTmsApi };
